/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class ContractPricingDirectiveController {
        public static $inject: string[] = [
            '$q',
            '$scope',
            '$filter',
            '$mdDialog',
            '$mobilityCompanyAuthentication',
            'CurrentUser',
            'DealerwareCreditCardCollection',
            'PdfHelperService',
            '$dealerwareLoading',
            '$dealerwareNotification'
        ];

        public contract: any;
        public disableSettleBalance: boolean = false;
        public editingCC: boolean = false;
        public savingCC: boolean = false;
        public creditCardDetails: any = {};
        public availableAdjustments: any;

        constructor(public $q: any,
                    public $scope: any,
                    public $filter: any,
                    public $mdDialog: any,
                    public auth: any,
                    public CurrentUser: any,
                    public creditCardCollection: any,
                    public PdfHelperService: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any) {
            if (this.showAccounting) {
                this.$scope.$watch(() => {
                    return this.contract.currentInvoice ? this.contract.currentInvoice.id : undefined;
                }, (invoiceId: number) => {
                    if (invoiceId) { this.initPricing(); }
                });
            }
        }

        public get contractCreditCard() : any {
            if (!this.creditCardDetails.contractCreditCardId) { return undefined; }

            return $.grep(this.creditCardDetails.userCreditCards, (cc: any) => {
                return cc.data.id === Number(this.creditCardDetails.contractCreditCardId);
            })[0];
        }

        public get settleBalanceLabel() : string {
            if (!this.contract.currentInvoice) { return undefined; }

            var balance = this.contract.currentInvoice.balance;

            return balance === 0 ? 'No Balance Due' :
                (balance > 0 ? 'Charge ' : 'Credit ') +
                this.$filter('customCurrency')(Math.abs(balance),
                                               this.contract.currentInvoice.currencyCode);
        }

        public get showAccounting() : boolean {
            return this.auth.location.settings.customers_charged && this.CurrentUser.user.hasRole('accounting');
        }

        public initPricing() : void {
            var loader = this.$dealerwareLoading.show('Loading...');

            this.$q.all([
                this.creditCardCollection.index({
                    promise: true,
                    params: {
                        location_id: this.contract.locationId,
                        customer_id: this.contract.contractDetails.data.customer_id
                    }
                }).then(
                    (creditCards: any) => {
                        if (!creditCards.data.length) { return; }

                        this.creditCardDetails.userCreditCards = creditCards.data;
                        this.creditCardDetails.contractCreditCardId = this.contract.contractDetails.data.credit_card_id;

                        if (!this.creditCardDetails.contractCreditCardId) {
                            this.creditCardDetails.contractCreditCardId = $.grep(creditCards.data, (cc: any) => {
                                return cc.data.default;
                            })[0].data.id;
                        }
                    },
                    (response: any) => { this.$dealerwareNotification.apiError(response); }
                ),
                this.contract.DealerwareContractModel.loadAvailableAdjustments({
                    promise: true,
                    params: {
                        location_id: this.contract.locationId,
                        id: this.contract.contractId
                    }
                }).then(
                    (adjustments: any) => {
                        this.availableAdjustments = adjustments.data.sort((a: any, b: any) => {
                            if (a.label === 'Other') { return 1; };
                            if (b.label === 'Other') { return -1; }
                            return a.label < b.label ? -1 : 1;
                        });
                    },
                    (response: any) => { this.$dealerwareNotification.apiError(response); }
                )
            ]).finally(() => {
                loader.close();
            });
        }

        public handleKeypress(e: any) : void {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        }

        public updateCreditCard() : void {
            this.savingCC = true;
            this.contract.contractDetails.data.credit_card_id = this.creditCardDetails.contractCreditCardId;
            this.contract.contractDetails.$updateCreditCard({
                promise: true,
                params: { location_id: this.contract.locationId }
            }).then(
                () => { this.editingCC = false; },
                (response: any) => { this.$dealerwareNotification.apiError(response); }
            ).finally(() => { this.savingCC = false; });
        }

        public settleBalance() : void {
            var loader = this.$dealerwareLoading.show('Please Wait...');
            this.contract.contractDetails.$handleOutstandingBalance({
                promise: true,
                params: { location_id: this.contract.locationId }
            }).then(
                () => {
                    this.contract.loadCurrentInvoice().finally(
                        () => {
                            loader.close();
                            this.$dealerwareNotification.toast('Complete!');
                        }
                    );
                },
                (response: any) => {
                    this.contract.loadCurrentInvoice().finally(
                        () => {
                            loader.close();
                            this.$dealerwareNotification.apiError(response);
                        }
                    );
                }
            );
        }

        public showReceipt() : void {
            var loader = this.$dealerwareLoading.show('Loading...');
            this.contract.DealerwareContractModel.getReceiptPdf(this.contract).then((response: any) => {
                this.PdfHelperService.streamPdfToNewWindow(response.data);
            }).catch((response: any) => {
                this.$dealerwareNotification.apiError(
                    response.message ? response : 'Receipt couldn\'t be opened'
                );
            }).finally(() => { loader.close(); });
        }

        public clearAdjustments() : void {
            this.$mdDialog.show(this.$mdDialog.confirm()
                .title('Clear Adjustments')
                .textContent('This action will remove all existing pricing adjustments and cannot be undone.')
                .ariaLabel('confirm')
                .ok('Continue')
                .cancel('Cancel')
            ).then(() => {
                var loader = this.$dealerwareLoading.show('Please Wait...');
                this.contract.DealerwareContractModel.clearAdjustments({
                    promise: true,
                    params: {
                        location_id: this.contract.locationId,
                        id: this.contract.contractId
                    }
                }).then(() => {
                    this.contract.loadCurrentInvoice().finally(() => {
                        loader.close();
                        this.$dealerwareNotification.toast('Complete!');
                    });
                }, (response: any) => {
                    loader.close();
                    this.$dealerwareNotification.apiError(response);
                });
            });
        }

        public showChargeCreditBanner(): boolean {
            return this.contract.currentInvoice && this.showAccounting && ! (this.disableSettleBalance || this.contract.currentInvoice.balance === 0);
        }
    }

    getDealerwareWebComponentsModule().controller('ContractPricingDirectiveController', ContractPricingDirectiveController);

    export class ContractPricingDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ContractPricingDirectiveController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   { contract: '=' };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/contract/pricing/contract_pricing_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareContractPricing",() => new ContractPricingDirective());
 }
